<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />
  <p-confirmDialog />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'TaxAuthorization_Title' | translateWF: 'Tax Authorizations' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" [disabled]="!canCreate()" (click)="openCreate()" />
        </div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        @if (siteBusiness(); as business) {
          {{ 'TaxAuthorization_Scope' | translateWF: 'Fiscal ranges issued by' }} <strong>{{ business.name }}</strong
          >.
          {{
            'TaxAuthorization_Scope_Hint'
              | translateWF
                : "A provider's own authorization is registered on their Business
        Details page."
          }}
        }
      </p>
    </div>

    @if (siteBusinessResolved() && !siteBusiness()) {
      <p-message
        severity="warn"
        styleClass="w-full mb-4"
        [text]="
          siteBusinessError() ??
          ('TaxAuthorization_NoSiteBusiness'
            | translateWF
              : 'This site has no internal company configured, so there is nothing to issue fiscal ranges under. Mark the business that operates this site as Internal Company in Businesses.')
        "
      />
    }

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'TaxAuthorization_Title' | translateWF: 'Tax Authorizations'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="paginatedRecords()" [rowTrackBy]="trackByRecordId" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'TaxAuthorization_Entity' | translateWF: 'Document' }}</th>
                <th>{{ 'Cai_DocumentTypes' | translateWF: 'Covers' }}</th>
                <th>{{ 'TaxAuthorization_Number' | translateWF: 'Authorization Number' }}</th>
                <th>{{ 'Cai_Range' | translateWF: 'Range' }}</th>
                <th>{{ 'TaxAuthorization_Next' | translateWF: 'Next' }}</th>
                <th>{{ 'Cai_Validity' | translateWF: 'Validity' }}</th>
                <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
                <th class="text-right">{{ 'Actions' | translateWF: 'Actions' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let row = getRowData(rowData);
              <tr>
                <td>
                  @if (!row.isSystem) {
                    <a class="cs-table-link" (click)="openEdit(row)">{{ entityLabel(row.entityDefinitionCode) }}</a>
                  } @else {
                    {{ entityLabel(row.entityDefinitionCode) }}
                  }
                </td>
                <td>{{ coverageLabel(row.documentTypes) || '—' }}</td>
                <td class="font-mono text-sm">{{ row.authorizationNumber }}</td>
                <td class="font-mono text-xs text-[var(--p-text-muted-color)]">{{ row.startRange }} – {{ row.endRange }}</td>
                <td class="font-mono text-xs">
                  @if (row.nextNumber) {
                    {{ row.nextNumber }}
                  } @else {
                    <span class="text-[var(--p-text-muted-color)]">{{ 'TaxAuthorization_Exhausted' | translateWF: 'Exhausted' }}</span>
                  }
                </td>
                <td class="text-xs text-[var(--p-text-muted-color)]">{{ row.startDate | date: 'dd/MM/yyyy' }} → {{ row.endDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center">
                  <p-tag [severity]="row.active ? 'success' : 'secondary'" [value]="(row.active ? 'Active' : 'Inactive') | translateWF: (row.active ? 'Active' : 'Inactive')" />
                  @if (row.isSystem) {
                    <p-tag class="ml-1" severity="info" [value]="'Cai_System' | translateWF: 'System'" />
                  }
                </td>
                <td class="text-right">
                  @if (row.isSystem) {
                    <span class="text-xs text-[var(--p-text-muted-color)]"><i class="pi pi-lock"></i></span>
                  } @else {
                    <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" (click)="openEdit(row)" />
                    @if (row.active) {
                      <p-button icon="pi pi-ban" severity="danger" [text]="true" [rounded]="true" (click)="confirmDeactivate(row)" />
                    }
                  }
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="text-center text-sm text-[var(--p-text-muted-color)] py-6">
                  {{ 'TaxAuthorization_Empty' | translateWF: 'No tax authorizations found.' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
